import type { IUnmatchedSlackRow } from '@skystone/shared';
import { Badge } from '@/components/ui';
import { Button } from '@/components/ui/Button';

interface UnmatchedSlackRowProps {
  row: IUnmatchedSlackRow;
  onLink: (row: IUnmatchedSlackRow) => void;
  onCreate: (row: IUnmatchedSlackRow) => void;
  onMarkAsBot: (row: IUnmatchedSlackRow) => void;
}

export function UnmatchedSlackRow({ row, onLink, onCreate, onMarkAsBot }: Readonly<UnmatchedSlackRowProps>) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t py-3 first:border-t-0 first:pt-0">
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <span className="truncate font-medium text-foreground">{row.displayName}</span>
            {row.isBot && <Badge variant="warning">bot</Badge>}
            {row.reason === 'ambiguous' && <Badge variant="warning">ambiguous</Badge>}
          </div>
          <div className="text-xs text-muted-foreground">
            {row.realName && row.realName !== row.displayName && (
              <span className="mr-2">({row.realName})</span>
            )}
            <span className="mr-2">{row.email ?? '—'}</span>
            <span className="font-mono">{row.slackId}</span>
          </div>
        </div>
      </div>
      <div className="flex gap-2">
        <Button size="sm" onClick={() => onLink(row)}>Link to Person</Button>
        <Button size="sm" variant="ghost" onClick={() => onCreate(row)}>Create new</Button>
        <Button size="sm" variant="ghost" onClick={() => onMarkAsBot(row)}>Mark as bot</Button>
      </div>
    </div>
  );
}
